module.exports = __webpack_public_path__ + "static/img/redsys.0c3f6f97.png";